"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PUBLIC_VIDEO = exports.GET_SINGLE_VIDEO_PLAY_URLS = exports.GET_DOWNLOAD_URL = void 0;
const helpers_1 = require("../../client/helpers");
const fragments_1 = require("../channel/fragments");
exports.GET_DOWNLOAD_URL = `
  query GetDownload($id: ID!) {
    video(filter: { id: $id }) {
      download(type: CONTENT) {
        entity {
          url
        }
      }
    }
  }
`;
exports.GET_SINGLE_VIDEO_PLAY_URLS = `
  query GetSingleVideoPlayUrls($id: ID!, $type: VideoPlayType!) {
    video(filter: { id: $id }) {
      play(type: $type) {
        entity {
          hls
        }
      }
    }
  }
`;
exports.GET_PUBLIC_VIDEO = `
  query GetPublicVideo($id: ID!) {
    video(filter: { id: $id }) {
      ...PublicVideoFragment
    }
  }
  ${fragments_1.PUBLIC_VIDEO_FRAGMENT}
`;
//# sourceMappingURL=queries.js.map